import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=030b0759&scoped=true&"
import script from "./ticketInfo.vue?vue&type=script&lang=js&"
export * from "./ticketInfo.vue?vue&type=script&lang=js&"
import style0 from "./ticketInfo.vue?vue&type=style&index=0&id=030b0759&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030b0759",
  null
  
)

export default component.exports